import { PERMISSIONS } from '@moleculeone/auth';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';

import ProtectedRoute from '@f/components/shared/protected/ProtectedRoute';
import { useDefaultRedirect, useStartingMaterialDatasetUpload } from '@f/hooks';
import { findDatasets } from '@f/services/starting-material/starting-material.actions';

import cls from './Dashboard.module.css';
import AdministrationPage from './administration/AdministrationPage';
import BatchSearchRequestListPage from './batch-searches/BatchSearchRequestListPage';
import { CreateBatchSearchPage } from './batch-searches/pages/create-batch-search/CreateBatchSearchPage';
import SingleBatchSearchPage from './batch-searches/pages/single-batch-search/SingleBatchSearchPage';
import ReportListPage from './reports/ReportListPage';
import SingleReportPage from './reports/pages/single-report/SingleReportPage';
import SettingsPage from './settings/SettingsPage';
import StartingMaterialsPage from './starting-materials/StartingMaterialsPage';
import SynthesisBrowser from './tools/synthesis-browser/SynthesisBrowser';

function Dashboard() {
  const dispatch = useDispatch();
  const match = useRouteMatch();

  const defaultRedirect = useDefaultRedirect(
    [
      {
        path: '/dashboard/batch',
        permissions: [PERMISSIONS.RETRO.APP.READ],
      },
    ],
    '/'
  );

  useStartingMaterialDatasetUpload();

  useEffect(() => {
    dispatch(findDatasets());
  }, []);

  return (
    <main className={cls.dashboard}>
      <Switch>
        <Route path={`${match.path}/settings`} component={SettingsPage} />
        <ProtectedRoute
          path={`${match.path}/administration`}
          allowedPermissions={[PERMISSIONS.RETRO.APP.ADMIN]}
          component={AdministrationPage}
        />
        <ProtectedRoute
          exact
          path={`${match.path}/batch`}
          allowedPermissions={[PERMISSIONS.RETRO.APP.READ]}
          component={BatchSearchRequestListPage}
        />
        <ProtectedRoute
          exact
          path={`${match.path}/batch/new`}
          allowedPermissions={[PERMISSIONS.RETRO.APP.WRITE]}
          component={CreateBatchSearchPage}
        />
        <ProtectedRoute
          path={`${match.path}/batch/:batchSearchId`}
          allowedPermissions={[PERMISSIONS.RETRO.APP.READ]}
          component={SingleBatchSearchPage}
        />
        <Route path={`${match.path}/starting-materials`} component={StartingMaterialsPage} />
        <ProtectedRoute
          exact
          path={`${match.path}/reports`}
          allowedPermissions={[PERMISSIONS.RETRO.APP.READ]}
          component={ReportListPage}
        />
        <ProtectedRoute
          exact
          path={`${match.path}/reports/:reportId`}
          allowedPermissions={[PERMISSIONS.RETRO.APP.READ]}
          component={SingleReportPage}
        />
        <ProtectedRoute
          exact
          path={`${match.path}/synthesis-browser`}
          allowedPermissions={[PERMISSIONS.RETRO.DEBUG]}
          component={SynthesisBrowser}
        />

        <Redirect exact from="/dashboard" to={defaultRedirect} />
      </Switch>
    </main>
  );
}
Dashboard.propTypes = {
  match: PropTypes.object,
};

export default Dashboard;
